<template>
  <div class="toggle">
    <portal to="menu-toggler">
      <div class="toggle-button">
        <UiBaseIcon v-bind="humburgerIcon" @click="toggleMenu" />
      </div>
    </portal>

    <portal to="backdrop">
      <div v-if="isOpened" class="backdrop" @click="closeMenu"></div>
    </portal>
  </div>
</template>

<script>
import UiBaseIcon from '@/components/icons/UiBaseIcon.vue'
// import { disablePageScroll, enablePageScroll, clearQueueScrollLocks } from 'scroll-lock'

export default {
  components: { UiBaseIcon },
  data() {
    return {
      isOpened: false,
      target: null,
      humburgerIcon: {
        'icon-name': 'menuHamburger',
        color: '#7a7a7a',
        width: '24px',
        height: '24px',
      },
    }
  },
  mounted() {
    this.target = document.getElementsByClassName('nav')[0]
  },
  created() {
    this.$bus.$on('close-menu', this.closeMenu)
  },
  beforeDestroy() {
    this.$bus.$off('close-menu', this.closeMenu)
  },
  methods: {
    toggleMenu(e) {
      if (this.isOpened) {
        this.closeMenu()
      } else {
        this.openMenu()
      }
    },
    openMenu() {
      this.isOpened = true
      this.$parent.$refs.menu.classList.add('opened-menu')

      // disablePageScroll(this.target)
    },
    closeMenu() {
      this.isOpened = false
      this.$parent.$refs.menu.classList.remove('opened-menu')

      // enablePageScroll(this.target)
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle {
  position: fixed;

  @include transition(left 0.1s ease);
}

.toggle-button {
  display: block;

  @include media_tablet() {
    display: none;
  }
}

.backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 4;
  background: rgba(0, 0, 0, 0.5);
}
</style>
